import styled from 'styled-components'
import { Flex } from 'vvs-uikit'

export const OptionFlex = styled(Flex)<{ selected?: boolean }>`
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 12px;
  border: 2px solid transparent;
  ${({ selected, theme }) =>
    selected &&
    `
    background: ${theme.colors.nightBlue};
    border: 2px solid ${theme.colors.primary};
  `}

  gap: 12px;
  cursor: pointer;
`

export const DetailText = styled(Flex)`
  color: white;
  font-size: 13px;
`
